import React from "react";
import { createRoot } from "react-dom/client";
import CssBaseline from "@mui/material/CssBaseline";
import { Provider as ReactProvider } from "react-redux";
import { QueryClientProvider } from "@tanstack/react-query";
import * as Sentry from "@sentry/react";
import App from "./App";
import { queryClient } from "./helpers/queryClient";
import { WalletSessionProvider } from "./hooks/useWallet";
import reportWebVitals from "./reportWebVitals";
const container = document.getElementById("root");
import generateStore from "./redux/index";
const root = createRoot(container);
const store = generateStore();

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DNS,
  // local runs send nothing (errors, sessions or replays)
  enabled: window.location.hostname !== "localhost",
  environment: import.meta.env.VITE_CHAIN === "MAINNET" ? "production" : "staging",
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  // URLs that receive the tracing headers
  tracePropagationTargets: ["localhost"],
  // Performance Monitoring
  // 20% of the transactions in production, all of them in staging
  tracesSampleRate: import.meta.env.VITE_CHAIN === "MAINNET" ? 0.2 : 1.0,
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

root.render(
  <React.StrictMode>
    <ReactProvider store={store}>
      <QueryClientProvider client={queryClient}>
        <WalletSessionProvider>
          <CssBaseline />
          <App />
        </WalletSessionProvider>
      </QueryClientProvider>
    </ReactProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
